import React, { useEffect, useState } from "react";
import Header from "../component/common/Header";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { POSTREQUEST } from "./helpers/ServiceRequest";

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [oldPasswordError, setOldPasswordError] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const { user } = useAuth();
  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
  let navigate = useNavigate();


  const resetPassword = async (e) => {
    e.preventDefault();
    setDisabled(true);
    let resetURL = process.env.REACT_APP_API_URL + "/change-password";
    if (confirmPassword && newPassword) {
      let payload = {
        OldPassword: oldPassword,
        NewPassword: newPassword,
        ConfirmPassword: confirmPassword,
      };
      let response = await POSTREQUEST(resetURL, payload, user.jwtToken);
      if (response?.data) {
        setSuccessMessage("Password changed successfully")
        setDisabled(false);
        setConfirmPasswordError(false);
        setErrorMessage("");
        setOldPassword("")
        setNewPassword("")
        setConfirmPassword("")
        setDisabled(true);
        setSuccessMessage("")
      }
      else {
        setConfirmPasswordError(false);
        let message = response?.error?.message || "Somthing went wrong";
        setErrorMessage(message);
      }
    }
  };
  return (
    <React.Fragment>
      <Header />
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-5 pb-4">
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <form onSubmit={resetPassword}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Old Password
                      </label>
                      <div className="col">
                        <input
                          type="password"
                          value={oldPassword}
                          className={
                            "form-control input-md " +
                            (oldPasswordError ? " is-invalid" : "")
                          }
                          placeholder="Enter Old Password"
                          onChange={(e) => {
                            setErrorMessage("")
                            setOldPasswordError(false);
                            setOldPassword(e.target.value);
                            if (
                              e.target.value &&
                              newPassword &&
                              confirmPassword
                            ) {
                              setDisabled(false);
                            } else {
                              setDisabled(true);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        New Password
                      </label>
                      <div className="col">
                        <input
                          type="password"
                          className={
                            "form-control input-md " +
                            (newPasswordError ? " is-invalid" : "")
                          }
                          placeholder="Enter New Password"
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            if (
                              e.target.value &&
                              oldPassword &&
                              confirmPassword
                            ) {
                              setDisabled(false);
                              if (
                                newPassword != e.target.value &&
                                confirmPassword !== ""
                              ) {
                                setNewPasswordError(true);
                                setConfirmPasswordError(true);
                                setDisabled(true);
                              } else {
                                setNewPasswordError(false);
                                setConfirmPasswordError(false);
                                setDisabled(false);
                              }
                            } else {
                              setDisabled(true);
                            }
                          }}
                          value={newPassword}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Confirm Password
                      </label>
                      <div className="col">
                        <input
                          type="password"
                          className={
                            "form-control input-md " +
                            (confirmPasswordError ? " is-invalid" : "")
                          }
                          placeholder="Enter Confirm Password"
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            if (e.target.value && oldPassword && newPassword) {
                              setDisabled(false);
                              if (newPassword != e.target.value) {
                                setNewPasswordError(true);
                                setConfirmPasswordError(true);
                                setDisabled(true);
                              } else {
                                setNewPasswordError(false);
                                setConfirmPasswordError(false);
                                setDisabled(false);
                              }
                            } else {
                              setDisabled(true);
                            }
                          }}
                          value={confirmPassword}
                        />
                      </div>
                    </div>

                    {errorMessage && (
                      <div className="text-danger text-center">
                        {" "}
                        {errorMessage}{" "}
                      </div>
                    )}
                    {successMessage && (
                      <div className="text-success text-center">
                        {" "}
                        {successMessage}{" "}
                      </div>
                    )}
                  </div>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        disabled={disabled}
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default ChangePassword;
